export enum ConsultPrescriptionState {
  New = 0,
  Cancelled = 1,
  Submitted = 2,
  Approved = 3,
}
